import React, { FC } from 'react';
import Modal from 'react-modal'
import { Spinner } from 'react-activity';
import clsx from "clsx";
import 'react-activity/dist/react-activity.css';
import { useLocale } from '../../contexts/localeContext';
import { TranslationKeys } from '../../contexts/TranslationKeys';

interface FullScreenActivitySpinnerProps {
    message: string
}

const FullScreenActivitySipnner: FC<FullScreenActivitySpinnerProps> = ({ message }) => {
    const { translate } = useLocale();
    return (

        <Modal isOpen={true} ariaHideApp={false}
            overlayClassName="flex w-screen position-float fixed top-0 left-0 h-screen bg-opacity-75 bg-black z-50"
            className="bg-white border-none m-auto shadow select-none outline-none w-content overflow-hidden sm:rounded-lg z-50">
            <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden  transform transition-all sm:my-2 sm:align-middle sm:max-w-lg sm:w-full" >
                <div className="bg-white px-4 pt-2 pb-4 sm:p-6 sm:pb-4">
                    <div className="sm:flex sm:items-start">
                        <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12  sm:mx-0 sm:h-10 sm:w-10">
                            <div
                                className={clsx(
                                    "flex items-center h-32 w-32 ",
                                    "mx-auto text-3xl select-none"
                                )}
                            >
                                <div style={{ left: '30rem' }} className="mx-auto h-12 w-auto flex justify-center" ><Spinner
                                    color="black"
                                    size={32}
                                    speed={1}
                                    animating={true} /></div>
                            </div>
                        </div>
                        <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                            <div className="font-semibold text-base mb-3 text-portal-blue-primary">
                                {translate.byKey(TranslationKeys.processing)}
                            </div>
                            <div className="mt-2">
                                <p className="text-sm text-gray-500 break-words whitespace-normal max-w-xs">
                                    {message}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </Modal>

    );
}

export default FullScreenActivitySipnner;
